import _debounce from 'lodash/debounce';
import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-hook-form';
import { event } from '@zillow/universal-analytics';
import CheckboxField from '../Fields/CheckboxField.js';
import EmailField from '../Fields/EmailField.js';
import HiddenField from '../Fields/HiddenField.js';
import NameField from '../Fields/NameField.js';
import PhoneField from '../Fields/PhoneField.js';
import RadioField from '../Fields/RadioField.js';
import SelectField from '../Fields/SelectField.js';
import TextField from '../Fields/TextField.js';

var FieldComponents = {
  CheckboxField: CheckboxField,
  EmailField: EmailField,
  HiddenField: HiddenField,
  PhoneField: PhoneField,
  RadioField: RadioField,
  SelectField: SelectField,
  NameField: NameField,
  TextField: TextField
};

// Handle field change, debounced by 3 seconds.
var handleFieldChange = _debounce(function (value, component) {
  var cmsInfo = {
    block_type_cd: 'form_field',
    block_id: component ? component : '',
    block_displayed_txt: value.target.name ? value.target.name : ''
  };
  sendInteractionEvent(cmsInfo);
}, 3000);

/**
 * Sends an interaction event with the provided CMS information.
 *
 * @param {Object} cmsInfo - The cms_info object to be included in the event.
 * @return {void}
 */
var sendInteractionEvent = function sendInteractionEvent(cmsInfo) {
  var newLaneData = {
    envelope: {
      event_type_id: '2056',
      event_type_version_id: '2',
      event_template_id: '126',
      event_template_version_id: '1'
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms_form',
      trigger_object_nm: 'no_trigger_object'
    },
    semantic: {
      semantic_event_nm: 'cms_engagement'
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
var ApexField = function ApexField(_ref) {
  var component = _ref.component,
    defaultValue = _ref.defaultValue,
    formData = _ref.formData,
    help = _ref.help,
    label = _ref.label,
    options = _ref.options,
    placeholder = _ref.placeholder,
    required = _ref.required;
  var FieldComponent = FieldComponents[component] || TextField;
  var formStateProxy = useFormState();
  var formState = {
    isSubmitting: formStateProxy.isSubmitting
  };
  return /*#__PURE__*/React.createElement(FieldComponent, {
    config: {
      validate: function validate(value) {
        // Use !value because this will ensure if a checkbox is "required" it
        // must get checked. And !value will account for blank string "" and `undefined`.
        if (required && !value) {
          return 'Required';
        }
        return null;
      }
    },
    label: label,
    defaultValue: defaultValue,
    name: formData,
    required: required,
    description: help,
    placeholder: placeholder,
    options: options,
    disabled: formState.isSubmitting,
    onChange: function onChange(value) {
      handleFieldChange(value, component);
    }
  });
};
ApexField.propTypes = process.env.NODE_ENV !== "production" ? {
  component: PropTypes.string.isRequired,
  formData: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  help: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }))
} : {};
ApexField.defaultProps = {
  help: undefined,
  placeholder: undefined,
  defaultValue: undefined,
  options: undefined
};
var ApexField$1 = ApexField;

export { FieldComponents, ApexField$1 as default };
